import React from 'react';
import PropTypes from 'prop-types';
import lockImageSrc from '../../assets/images/protection/protection-lock.png';
import alarmImageSrc from '../../assets/images/protection/protection-alarm.png';
import shieldImageSrc from '../../assets/images/protection/protection-shield.png';
import financeImageSrc from '../../assets/images/protection/protection-finance.png';
import warningImageSrc from '../../assets/images/protection/protection-warning.png';
import checkImageSrc from '../../assets/images/protection/protection-check.png';
import styles from './ProtectedListV2.css';

const LIST = [
    {
        id: 1,
        name: 'Safety first',
        description: 'Keep hackers, scammers, and identity thieves from stealing your data and money.',
        imageUrl: lockImageSrc
    },
    {
        id: 2,
        name: 'Scam detection',
        description: 'Scan suspicious text messages, emails, and popups before you reply.',
        imageUrl: alarmImageSrc
    },
    {
        id: 3,
        name: 'Identity monitoring',
        description: 'Get alerts and insights to help prevent criminals from using your personal information.',
        imageUrl: shieldImageSrc
    },
    {
        id: 4,
        name: 'Account safeguards',
        description: 'Learn how to spot and flag clever traps designed to target your bank info.',
        imageUrl: financeImageSrc
    },
    {
        id: 5,
        name: 'Data breach check',
        description: 'Check if your current email or passwords appear in corporate leaks.',
        imageUrl: warningImageSrc
    },
    {
        id: 6,
        name: 'Peace of mind',
        description: 'Gain confidence online with simple tools built to keep you in control.',
        imageUrl: checkImageSrc
    }
];

function ProtectedListV2({ className }) {
    return (
        <ul className={`${styles.root} ${className}`}>
            {LIST.map(item => (
                <li key={item.id} className={styles.item}>
                    <img
                        className={styles.image}
                        alt={item.name}
                        src={item.imageUrl}
                    />
                    <div>
                        <p className={styles.name}>{item.name}</p>
                        <p className={styles.description}>{item.description}</p>
                    </div>
                </li>
            ))}
        </ul>
    );
}

ProtectedListV2.propTypes = {
    className: PropTypes.string
};

export {
    ProtectedListV2
};
